import { SignIn as r } from "../../SignIn/SignIn.js";
import { SignUp as e } from "../../SignUp/SignUp.js";
import { ConfirmSignUp as o } from "../../ConfirmSignUp/ConfirmSignUp.js";
import { ForceNewPassword as s } from "../../ForceNewPassword/ForceNewPassword.js";
import { SetupTOTP as i } from "../../SetupTOTP/SetupTOTP.js";
import { ConfirmSignIn as t } from "../../ConfirmSignIn/ConfirmSignIn.js";
import { ConfirmVerifyUser as m } from "../../VerifyUser/ConfirmVerifyUser.js";
import { VerifyUser as d } from "../../VerifyUser/VerifyUser.js";
import { ConfirmResetPassword as n } from "../../ResetPassword/ConfirmResetPassword.js";
import { ResetPassword as F } from "../../ResetPassword/ResetPassword.js";
const a = {
  Header: () => null,
  SignIn: {
    Header: r.Header,
    Footer: r.Footer
  },
  SignUp: {
    Header: e.Header,
    FormFields: e.FormFields,
    Footer: e.Footer
  },
  ConfirmSignUp: {
    Header: o.Header,
    Footer: o.Footer
  },
  SetupTOTP: {
    Header: i.Header,
    Footer: i.Footer
  },
  ConfirmResetPassword: {
    Header: n.Header,
    Footer: n.Footer
  },
  ConfirmSignIn: {
    Header: t.Header,
    Footer: t.Footer
  },
  VerifyUser: {
    Header: d.Header,
    Footer: d.Footer
  },
  ConfirmVerifyUser: {
    Header: m.Header,
    Footer: m.Footer
  },
  ForceNewPassword: {
    FormFields: s.FormFields
  },
  ResetPassword: {
    Header: F.Header,
    Footer: F.Footer
  },
  Footer: () => null
};
export { a as defaultComponents };